import React, { useState } from "react";
import { Nav, Tab, Form, Button } from "react-bootstrap";
import "./SystemConfigPanel.scss";

const SystemConfig = () => {
  return (
    <div className="dbCon SystemConfig">
      <div className="dbRight">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="PaymentSettings"
        >
          <Nav variant="pills" className="tabs mb-3">
            <Nav.Item>
              <Nav.Link eventKey="PaymentSettings">Payment Settings</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="NotificationTemplates">
                Notification Templates
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="PricingRules">Pricing Rules</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="SystemSettings">System Settings</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            {/* Payment Settings */}
            <Tab.Pane eventKey="PaymentSettings">
              <h4>Payment Gateway Integration</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">Gateway Provider</label>
                  <select className="formSelect">
                    <option>Stripe</option>
                    <option>PayPal</option>
                    <option>Razorpay</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">API Key</label>
                  <input
                    type="text"
                    placeholder="Enter API key"
                    className="formInput"
                  />
                </div>
                <Button variant="primary" className="mt-3">
                  Save
                </Button>
              </form>
            </Tab.Pane>

            {/* Notification Templates */}
            <Tab.Pane eventKey="NotificationTemplates">
              <h4>Email Notification Templates</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">Template Type</label>
                  <select className="formSelect">
                    <option>Booking Confirmation</option>
                    <option>Payment Success</option>
                    <option>Seat Cancellation</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Template Content</label>
                  <textarea
                    rows={5}
                    placeholder="Enter email message..."
                    className="formInput"
                  />
                </div>
                <Button variant="primary" className="mt-3">
                  Save Template
                </Button>
              </form>
            </Tab.Pane>

            {/* Pricing Rules */}
            <Tab.Pane eventKey="PricingRules">
              <h4>Pricing Rule Settings</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">Base Price Per Seat ($)</label>
                  <input
                    className="formInput"
                    type="number"
                    placeholder="e.g., 30"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Zone-Based Additional Fee
                  </label>
                  <input
                    className="formInput"
                    type="number"
                    placeholder="e.g., 5"
                  />
                </div>
                <Button variant="primary" className="mt-3">
                  Save Rules
                </Button>
              </form>
            </Tab.Pane>

            {/* System Settings */}
            <Tab.Pane eventKey="SystemSettings">
              <h4>System Parameters</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">Maximum Seats Per School</label>
                  <input className="formInput" type="number" />
                </div>
                <div className="mb-3">
                  <label className="form-label">Enable Notifications</label>
                  <select className="formSelect">
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <Button variant="primary" className="mt-3">
                  Save Settings
                </Button>
              </form>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default SystemConfig;
